import { render } from "./FinAccount.vue?vue&type=template&id=6c71fe84&scoped=true"
import script from "./FinAccount.vue?vue&type=script&lang=js"
export * from "./FinAccount.vue?vue&type=script&lang=js"

import "./FinAccount.vue?vue&type=style&index=0&id=6c71fe84&lang=less&scoped=true"

import exportComponent from "E:\\heguang\\hotel\\src\\manage\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c71fe84"]])

export default __exports__